jQuery(function(){

  // Handle table tool tip actions

  jQuery('body').on('click', '.tooltip__text-link', function(e){
    e.preventDefault();
    var $this = jQuery(this);
    var $tooltip = $this.siblings('.tooltip__container-link');

    //Tooltip height Calculation
    var $tooltip_copy_height = $this.parent(".input__text-placeholder").children(".tooltip__container-link").find(".tooltip__copy").outerHeight()+21+40-6;
    if (jQuery(".tooltip__height-container").length) {
      jQuery(".tooltip__height-container .tooltip__container-link").innerHeight($tooltip_copy_height);
    }
    else {
      jQuery(".tooltip__component .tooltip__container-link").innerHeight($tooltip_copy_height);
    }
    // END Tooltip height Calculation

    //Position Tooltip container
    jQuery(".tooltip__text-link").each(function(index, element){
      var $tooltip_identifier = jQuery(this).outerHeight()+10;
      var $this = jQuery(this);
      $this.siblings(".tooltip__container-link").css("top",$tooltip_identifier+"px");
    });
    //END Position Tooltip container

    jQuery('.tooltip__container--open').each(function(index, element){
      if($this != jQuery(element)) {
        jQuery(element).removeClass('tooltip__container--open');
      }
    });

    if(!$tooltip.hasClass('tooltip__container--open')) {
      $tooltip.addClass('tooltip__container--open');
    } else {
      if(e.type != 'mouseover')
      $tooltip.removeClass('tooltip__container--open');
    }

    //Add AODa attributes 
    setAttributes = function (el, attrs) {
      for (var key in attrs) {
        el.setAttribute(key, attrs[key]);
      }
    }
    setAttributes(document.querySelector('.tooltip__container--open'), {
      "tabindex": "-1",
      "aria-atomic": "true",
      "aria-live": "assertive",
    });  

    return false;
  });

  // Close Tooltip
  jQuery(document).on('click', function(e){
    var $target = jQuery(e.target);
    if(!$target.hasClass('tooltip__container--open')) {
      jQuery('.tooltip__container--open').removeClass('tooltip__container--open');
    }
  });

  jQuery('body').on('click', '.tooltip__container', function () {
     jQuery('.tooltip__container--open').removeClass('tooltip__container--open');
  });

});

//Tooltip height on window resize
jQuery(window).on('resize', function(){
  //Height Tooltip container
  jQuery(".input__text-placeholder .tooltip__container-link").each(function(index, element){
    var $this = jQuery(this);
    var $tooltip_copy_height_resize = jQuery(this).children(".tooltip__copy").outerHeight()+21+40-6;
    $this.innerHeight($tooltip_copy_height_resize);
  });
  //Position Tooltip container
  jQuery(".tooltip__text-link").each(function(index, element){
    var $tooltip_identifier = jQuery(this).outerHeight()+10;
    var $this = jQuery(this);
    $this.siblings(".tooltip__container-link").css("top",$tooltip_identifier+"px");
  });
});
